// Navbar.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo-bvt.png'; // reemplaza con tu logo

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed top-6 left-1/2 transform -translate-x-1/2 w-[90%] bg-white/90 backdrop-blur-md shadow-md rounded-xl z-50">
      <div className="flex justify-between items-center h-16 px-6">
        <div className="flex items-center space-x-2">
          <img src={logo} alt="Logo BVT" className="h-14" />          
        </div>

        <div className="space-x-6 hidden md:flex">
          <Link to="/" className="text-gray-700 hover:text-[#003366] transition">Inicio</Link>
          <Link to="/servicios" className="text-gray-700 hover:text-[#003366] transition">Servicios</Link>
          <Link to="/nosotros" className="text-gray-700 hover:text-[#003366] transition">Nosotros</Link>
          <Link to="/contacto" className="text-gray-700 hover:text-[#003366] transition">Contacto</Link>
        </div>

        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)} className="text-gray-700 text-2xl">☰</button>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden px-6 pb-4">
          <Link to="/" className="block py-2 text-gray-700 hover:text-[#003366]" onClick={() => setIsOpen(false)}>Inicio</Link>
          <Link to="/servicios" className="block py-2 text-gray-700 hover:text-[#003366]" onClick={() => setIsOpen(false)}>Servicios</Link>
          <Link to="/contacto" className="block py-2 text-gray-700 hover:text-[#003366]">Contacto</Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;